import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useState } from "react";
import CustomToaster from "../../../../Ui/toaster/CustomToaster";
import FormHelperText from "@mui/material/FormHelperText";
import Cookies from "universal-cookie";
import CloseIcon from "@mui/icons-material/Close";
import { Logger } from "../../../../Logger/Logger";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 350,
  border: 0,
  bgcolor: "background.paper",
  borderRadius: 6,
  boxShadow: 24,
  p: 4,
};
export const StatusModal = ({ modalData, setStatusOpen, statusOpen }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [disable, setDisable] = useState(false);
  const cookies = new Cookies();
  const apiKey = cookies.get("UserLogin");
  const [statusChange, setStatusChange] = useState({
    status: "",
  });
  const handleOpen = () => setStatusOpen(true);
  const handleClose = () => setStatusOpen(false);
  const navigate = useNavigate();
  const id = modalData.id;
  const [toaster, setToaster] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [variant, setVariant] = useState("");
  const [error, setError] = useState(null);
  const handleChange = (event) => {
    setStatusChange({
      ...statusChange,
      status: event.target.value,
    });
    setError(null);
  };

  const handleClick = () => {
    setDisable(true)
    if (statusChange.status !== "") {
      axios
        .patch(`${BASE_URL}api/ticket/change_status/${id}/`, statusChange, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })
        .then((res) => {
          setToaster(true);
          setTitle("Success");
          setDisable(false)
          setSubTitle(
            `Status changed to ${statusChange.status} for Ticket No: ${id}`
          );
          setVariant("success");
          setTimeout(() => {
            setToaster(false);
            setStatusOpen(false);
          }, 1000);
        })
        .catch((error) => {
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    } else {
      setError("Please Select an Option");
    }
  };
  Logger.debug("statusChange.status", statusChange.status);
  return (
    <div className="ml-[250px] mt-[100px]">
      {!toaster && (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={statusOpen}
          onClose={handleClose}
          // closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={statusOpen}>
            <Box sx={style}>
              <CloseIcon
                className="ml-[90%] cursor-pointer"
                onClick={() => setStatusOpen(false)}
              />
              <Box sx={{ minWidth: 120 }}>
                <h1 className="mb-[20px] text-center text-xl">Change Status</h1>
                <div className="flex flex-row justify-between">
                  <p className="mb-2">Ticket No: {modalData.id}</p>
                  <p className="mb-2">Current: {modalData.status}</p>
                </div>

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Change Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={statusChange.status}
                    label="Change Status"
                    onChange={handleChange}
                  >
                    <MenuItem value="In Progress">In Progress</MenuItem>

                    <MenuItem value="Resolved">Resolved</MenuItem>
                  </Select>
                  {setStatusChange.status == null ? (
                    <FormHelperText sx={{ color: "red" }}>
                      {error}
                    </FormHelperText>
                  ) : (
                    <></>
                  )}
                </FormControl>
              </Box>
              <Button
                disabled={disable}
                variant="contained"
                className="!bg-[#05374F]"
                sx={{ position: "absolute", bottom: 20, right: 20 }}
                onClick={handleClick}
              >
                Done
              </Button>
            </Box>
          </Fade>
        </Modal>
      )}
      {toaster ? (
        <CustomToaster
          title={title}
          subTitle={subTitle}
          variant={variant}
        ></CustomToaster>
      ) : (
        <></>
      )}
    </div>
  );
};
